<template>
    <Row>
        <Col span="16">
            <h4>FlashTalking Campaign (Creative Library) Name</h4>
            <p class="tooltip">Campaign name as it appears in FlashTalking.</p>
            <p class="error">{{ ftCampaignNameError }}</p>
        </Col>
        <Col span="8">
            <Input
                v-model="ftCampaignName"
                placeholder="Campaign Name"
                data-testid="download-modal__flashtalking-campaign-name"
            />
        </Col>
    </Row>

    <Row>
        <Col span="16">
            <h4>Reference ID</h4>
            <p class="tooltip">Reference ID as it appears in FlashTalking.</p>
            <p class="error">{{ ftReferenceIdError }}</p>
        </Col>
        <Col span="8">
            <Input
                v-model="ftReferenceId"
                data-testid="download-modal__flashtalking-reference-id"
                placeholder="Reference ID"
            />
        </Col>
    </Row>

    <Divider size="small" />

    <DownloadOptionWrapper tooltip="Strip Dimensions from Version Name" class="flashtalking-strip-dimensions">
        <Checkbox v-model="stripDimensionsFromVersionName" data-testid="download-modal__flashtalking-strip-dimensions">
            <h4>Strip Dimensions</h4>
        </Checkbox>
    </DownloadOptionWrapper>
</template>

<script lang="ts" setup>
import DownloadOptionWrapper from "@/components/Download/DownloadOptionWrapper.vue";
import { useDownloadFlashtalkingExcel } from "@/composables/download/useDownloadFlashtalkingExcel";

const { stripDimensionsFromVersionName, ftCampaignName, ftReferenceId, ftCampaignNameError, ftReferenceIdError } =
    useDownloadFlashtalkingExcel();
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;
.tooltip {
    font-size: 12.5px;
}

.error {
    color: $error-color;
    font-size: 10px;
    height: 8px;
}
</style>
